<h2 class="boels-checkout-title d-lg-block d-xl-block">
  {{ 'deliveryMode.shippingAddress' | transloco }}
</h2>

<form
  [formGroup]="deliveryFormState().deliveryForm()"
  (ngSubmit)="onSubmit(deliveryFormState())"
>
  <h3 class="h3" style="padding-top: 0px">
    {{ 'checkout.formBillingShipping.address.header' | transloco }}
  </h3>

  <div class="row address-fields">
    <boels-text-input
      class="col col-sm-12 street-name"
      [required]="true"
      name="line1"
      [label]="'checkout.formBillingShipping.address.streetName' | transloco"
      type="text"
      formControlName="line1"
      [formControl]="getControl('line1')"
      [maxlength]="maxInputLengths.STREET_S3"
    ></boels-text-input>
    <boels-text-input
      class="col col-sm-12 house-number"
      [required]="getStateMetaData('isHouseNumberRequired')()"
      name="line2"
      [label]="'checkout.formBillingShipping.address.houseNumber' | transloco"
      type="text"
      formControlName="line2"
      [formControl]="getControl('line2')"
      [maxlength]="maxInputLengths.HOUSE_NR_S3"
    ></boels-text-input>
  </div>

  <div class="row">
    <boels-text-input
      class="col col-md-6 col-sm-12"
      [required]="true"
      name="postalCode"
      [label]="'checkout.formBillingShipping.zipcode.label' | transloco"
      type="text"
      [formControlName]="'postalCode'"
      [formControl]="getControl('postalCode')"
      [customError]="getStateMetaData('postalCodeValidationMessage')()"
      [maxlength]="maxInputLengths.ZIP_CODE_S3"
    ></boels-text-input>

    <boels-text-input
      class="col col-md-6 col-sm-12"
      [required]="true"
      name="town"
      [label]="'checkout.formBillingShipping.city.label' | transloco"
      type="text"
      formControlName="town"
      [formControl]="getControl('town')"
      [maxlength]="maxInputLengths.CITY_S3"
    ></boels-text-input>
  </div>

  @if (getStateMetaData('countries')().countries.length !== 0) {
    <div class="select-container" formGroupName="country">
      <span class="label-content">
        {{ 'checkout.formBillingShipping.country.label' | transloco }}
      </span>
      <ng-select
        [ngClass]="{
          isInvalid: getControl('country', 'isocode').invalid,
        }"
        [searchable]="true"
        [clearable]="false"
        [items]="getStateMetaData('countries')().countries"
        bindLabel="name"
        bindValue="isocode"
        formControlName="isocode"
        (change)="getControl('country', 'isocode').setValue($event.isocode)"
      >
      </ng-select>
      <boels-form-errors
        [control]="getControl('country', 'isocode')"
      ></boels-form-errors>
    </div>
  }
  @if (deliveryFormState().registerdUser()) {
    <ng-container
      *ngTemplateOutlet="
        contactInformation;
        context: { $implicit: deliveryFormState() }
      "
    ></ng-container>
  }

  <div class="form-group">
    <h3 class="h3" style="padding-top: 0px">
      {{ 'checkout.formBillingShipping.optional.header' | transloco }}
    </h3>
    <label>
      <boels-textarea
        [maxlength]="maxInputLengths.INSTRUCTION_S3"
        [label]="'checkout.formBillingShipping.optional.label' | transloco"
        [formControl]="getControl('operationalDirections')"
        class="form-control"
        name="w3review"
        placeholder="{{
          'checkout.formBillingShipping.optional.placeholder_' +
            (deliveryFormState().registerdUser() ? 'short' : 'long') | transloco
        }}"
        formControlName="operationalDirections"
        rows="4"
        cols="50"
      ></boels-textarea>
    </label>
  </div>
  @if (getStateMetaData('validationResult')()) {
    <boels-address-validation
      [addressValidationResult]="getStateMetaData('validationResult')()"
      (replaceFields)="
        replaceWithSuggestion(deliveryFormState().deliveryForm(), $event)
      "
    ></boels-address-validation>
  }

  <hr class="divider" />

  <div class="btn-container">
    <button
      type="submit"
      action="next"
      boelsButton
      variant="primary-brand"
      [alwaysShowActionIcon]="true"
    >
      {{
        (getStateMetaData('continueWithValidationIssue')()
          ? 'deliveryMode.continueWithValidationIssue'
          : 'deliveryMode.continue'
        ) | transloco
      }}
    </button>

    <button
      boelsButton
      variant="secondary"
      action="none"
      (click)="goBack()"
      [icon]="faChevronLeft"
    >
      {{ 'deliveryMode.back' | transloco }}
    </button>
  </div>
</form>

<ng-template
  #contactInformation
  [boelsTemplateContext]="deliveryFormState()"
  let-deliveryFormState
>
  <div class="divider">
    <h3 class="h3" style="padding-top: 0px">
      {{ 'checkout.formBillingShipping.contact.header' | transloco }}
    </h3>

    <ng-container [formGroup]="deliveryFormState.deliveryForm()">
      <div class="row">
        <boels-text-input
          class="col col-md-12 col-sm-12"
          [required]="false"
          name="contactName"
          [label]="'checkout.formBillingShipping.contact.name' | transloco"
          type="text"
          formControlName="contactName"
          [formControl]="getControl('contactName')"
          [maxlength]="maxInputLengths.CONTACT_S3"
        ></boels-text-input>
      </div>

      <div class="phone-container">
        <span class="label-content">
          {{ 'checkout.formBillingShipping.contact.phone' | transloco }}
          <span class="optional-suffix">
            {{ 'form.optionalSuffix' | transloco }}
          </span>
        </span>
        <boels-phone
          [phoneControl]="getControl('contactPhone')"
          [maxLength]="maxInputLengths.PHONE_NUMBER_S3"
          [required]="false"
        ></boels-phone>
        <boels-form-errors
          [control]="getControl('contactPhone')"
          [hide]="
            !getControl('contactPhone').touched &&
            (!getControl('contactPhone').value ||
              getControl('contactPhone').value?.number?.length === 0)
          "
        ></boels-form-errors>
      </div>
    </ng-container>
  </div>
</ng-template>
